import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner, Button, Collapse, Card } from 'react-bootstrap';
import {
  FaChevronDown,
  FaChevronUp,
  FaFolderOpen,
  FaGavel,
  FaDollarSign,
} from 'react-icons/fa';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { format, strParaMonetario } from '~/Utils/Helpers';

const InformacoesJuridicas = ({ cpf }) => {
  const [informacoesJuridicas, setInformacoesJuridicas] = useState(null);
  const [buscandoProcessos, setBuscandoProcessos] = useState(false);
  const [processosExpandidos, setProcessosExpandidos] = useState({});

  const toggleProcessoExpansao = index => {
    setProcessosExpandidos(prev => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const obterValorCampoExtra = (processo, campo) => {
    if (!processo || !campo) return null;

    const objeto = processo.valoresCamposExtras.find(
      v => v.idCampoExtra === campo.id
    );

    if (!objeto) return null;

    switch (campo.tipo.valor) {
      case 'DATA':
        return format.date(objeto.valor);
      case 'DECIMAL':
        return strParaMonetario(objeto.valor);
    }

    return objeto.valor;
  };

  useEffect(() => {
    const buscarProcessosJuridicosPorCPF = async () => {
      try {
        setBuscandoProcessos(true);
        const response = await api.buscarProcessosJuridicosPorCPF(cpf);
        if (response) {
          setInformacoesJuridicas(response);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setBuscandoProcessos(false);
      }
    };

    if (cpf) {
      buscarProcessosJuridicosPorCPF(cpf);
    }
  }, [cpf]);

  return (
    <div className="mt-1">
      {buscandoProcessos && (
        <div className="text-center">
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="mr-2"
          />
          <label>Procurando dados...</label>
        </div>
      )}
      {!buscandoProcessos && (
        <div className="mt-">
          {informacoesJuridicas &&
            informacoesJuridicas.processos &&
            informacoesJuridicas.processos.length > 0 && (
              <div>
                <h4 className="text-center text-secondary">
                  <FaGavel className="me-2" /> Processos Judiciais
                </h4>
                <small className="text-secondary">
                  Processos judiciais encontrados por CPF do prospecto.
                </small>
              </div>
            )}
          {informacoesJuridicas &&
          informacoesJuridicas.processos &&
          informacoesJuridicas.processos.length > 0 ? (
            informacoesJuridicas.processos.map((processo, index) => {
              const isExpanded = processosExpandidos[index] || false;
              return (
                <Card key={index} className="mt-4 mb-3 border">
                  <Card.Body>
                    <Row className="align-items-center">
                      <Col md={11}>
                        <Row>
                          <Col md={12} className="mb-2">
                            <small>Autor do Processo: </small>
                            <strong>{processo.autorPrincipal.descricao}</strong>
                          </Col>
                          <Col md={6}>
                            <small>Número CNJ: </small>
                            <strong>
                              {processo.numeroCNJ} -{' '}
                              {processo.instanciaJudicial.descricao}
                            </strong>
                          </Col>
                          <Col md={6}>
                            <small>Réu Principal: </small>
                            <strong>{processo.reuPrincipal.descricao}</strong>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={1} className="text-center">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => toggleProcessoExpansao(index)}
                          aria-expanded={isExpanded}
                          aria-controls={`collapse-processo-${index}`}
                        >
                          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                        </Button>
                      </Col>
                      <Col md={6} className="mt-2">
                        <small>Tribunal: </small>
                        <strong>{processo.tribunal}</strong>
                      </Col>
                      <Col md={6} className="mt-2">
                        <small>Unidade: </small>
                        <strong>{processo.unidadeJudicial}</strong>
                      </Col>
                      <Col md={6} className="mt-2">
                        <small>Advogado do Autor: </small>
                        <strong>
                          {processo.advogadoAutorPrincipal
                            ? processo.advogadoAutorPrincipal
                            : 'Não Informado'}
                        </strong>
                      </Col>
                      <Col md={6} className="mt-2">
                        <small>Situação: </small>
                        <strong>
                          {processo.situacao
                            ? processo.situacao
                            : 'Não informado'}
                        </strong>
                      </Col>
                    </Row>
                    <Collapse in={isExpanded}>
                      <div id={`collapse-processo-${index}`}>
                        <hr />
                        {isExpanded && (
                          <div>
                            <h5 className="text-center text-secondary">
                              <FaFolderOpen className="me-2" /> Pastas do
                              Processo
                            </h5>
                            {informacoesJuridicas.pastas &&
                              informacoesJuridicas.pastas.length > 0 &&
                              informacoesJuridicas.pastas
                                .filter(
                                  pasta =>
                                    pasta.id === processo.id_pasta && isExpanded
                                )
                                .map((p, idx) => {
                                  return (
                                    <Row className="mt-2" key={idx}>
                                      <Col md={4} className="mt-2">
                                        <small>Código: </small>
                                        <strong>
                                          {p.prefixo}/{p.numero}
                                        </strong>
                                      </Col>
                                      <Col md={4} className="mt-2">
                                        <small>Assunto: </small>
                                        <strong>{p.assunto}</strong>
                                      </Col>
                                      <Col md={4} className="mt-2">
                                        <small>Situação: </small>
                                        <strong>{p.situacao}</strong>
                                      </Col>
                                      <Col md={6} className="mt-2">
                                        <small>Encarregado: </small>
                                        <strong>{p.encarregado}</strong>
                                      </Col>
                                    </Row>
                                  );
                                })}
                          </div>
                        )}
                        <hr />
                        {isExpanded && (
                          <div>
                            <h5 className="text-center text-secondary mb-3">
                              <FaDollarSign className="me-2" /> Detalhes da
                              venda
                            </h5>
                            <Row className="mt-2">
                              {informacoesJuridicas.campos_extras &&
                                informacoesJuridicas.campos_extras.map(
                                  campo => {
                                    const valorFormatado = obterValorCampoExtra(
                                      processo,
                                      campo
                                    );
                                    if (valorFormatado === null) return null;
                                    return (
                                      <Col
                                        md={6}
                                        className="mb-2"
                                        key={campo.id}
                                      >
                                        <small>{campo.nome}: </small>
                                        <strong>{valorFormatado}</strong>
                                      </Col>
                                    );
                                  }
                                )}
                            </Row>
                          </div>
                        )}
                      </div>
                    </Collapse>
                  </Card.Body>
                </Card>
              );
            })
          ) : (
            <div className="text-center py-5">
              <FaFolderOpen size={64} className="text-muted mb-3" />
              <h5 className="text-muted">Nenhum processo encontrado</h5>
              <p className="text-muted">
                Não foram encontrados processos judiciais para este CPF.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InformacoesJuridicas;
